import { render } from "./CreatePoBatch.vue?vue&type=template&id=d8a14252"
import script from "./CreatePoBatch.vue?vue&type=script&lang=js"
export * from "./CreatePoBatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__